<template>
  <div class="p-0">
    <div
      v-for="(layer, idx) in Array.from(contentStore.layers.values())
        .slice()
        .reverse()"
      :key="idx"
      class="d-flex m-2"
    >
      <button
        class="btn me-3 layer-label pt-1"
        :style="layerButtonColorStyle(layer)"
        style="width: 150px"
        @click="contentStore.changeCrtLayer(layer.label)"
      >
        {{ layer.label }}
      </button>
      <div class="d-flex">  
        <button
          class="btn btn-outline-danger me-3 ms-auto btn-sm"
          @click="contentStore.deleteLevel(layer.label)"
        >
          <i class="fa-solid fa-minus"></i>
        </button>
      </div>  
    </div>

    <form class="d-flex m-2" @submit.prevent="addNewLevel">
      <button class="btn btn-outline-success me-3 btn-sm" style="width: 100%" title="New Level">  
        <i class="fa-solid fa-plus"></i>
      </button>
    </form>
  </div>
</template>
<script setup>
import { useContentStore } from "@/stores/content";
const layerButtonColorStyle = (layer) => {
  return { backgroundColor: layer.color };
};
const contentStore = useContentStore();
const addNewLevel = () => {
  contentStore.createNewLevel(contentStore.chipThickness);
};
</script>

<style scoped>
.layer-label {
  color: white;
  border: none;
  border-radius: 5px;
  text-align: center;
}
</style>
